/* eslint-disable */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

// import for excel download
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem, Box } from "@mui/material";

//import context
import { GlobalProvider } from "context/GlobalContext";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import images
import CommonHeader from "components/MarketplaceComponents/MarketplaceHeader/CommonHeader";
import { assetImages } from "constants";
import InventoryHeader from "../Header/InventoryHeader";
import { useTranslation } from "react-i18next";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import InventoryFilterPopup from "../Popup/InventoryFilterPopup";
import SaveInventoryPopup from "../Popup/SaveInventoryPopup";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import { replaceListByIds } from "helper/Common/CommonHelper";

const InventoryListBody = () => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");
  const { t, i18n } = useTranslation(); //for translation

  // showSkeleton = true  → show skeleton (initial load + filter apply/reset)
  // showSkeleton = false → show table (search typing, pagination, etc.)
  const [showSkeleton, setShowSkeleton] = useState(false);

  const [inventoryList, setinventoryList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedInventories, setSelectedInventories] = useState([]);
  const [selectedInventory, setSelectedInventory] = useState(null);

  const [selectedTagId, setSelectedTagId] = useState(null);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // null = filter popup hasn't decided yet (skip API call)
  // []   = no default filter, fetch all
  // [...] = has filters, fetch filtered
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  // Global search states — MRT search is manual (server-side)
  const [globalSearch, setGlobalSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Pagination -------------------------------------------
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  // paginatin ends -----------------------------------

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //get all inventories
  const getAllInventories = async (searchTerm = "", withSkeleton = false) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_INVENTORIES;

      // Append search term if present
      if (searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("requestUrl in getAllInventories------>", requestUrl);

      const response = await getData(requestUrl);

      if (response.status) {
        setMessageType("success");
        setinventoryList(response.data);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowSkeleton(false);
      setIsDataReady(true);
      setShowAlert(true);
    }
  };

  const getFilteredInventoryList = async (
    searchTerm = "",
    withSkeleton = false,
  ) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_INVENTORIES_BY_FILTER +
        ``;

      // Append search term if present
      if (searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setMessageType("success");
        setinventoryList(response.data);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowSkeleton(false);
      setIsDataReady(true);
      setShowAlert(true);
    }
  };

  //function for delete bulk
  const deleteBulkInventories = async () => {
    if (selectedInventories.length > 0) {
      try {
        const listToBeUpdated = inventoryList.filter((item) =>
          selectedInventories.includes(item._id),
        );

        const apiData = {
          inventories: listToBeUpdated,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_INVENTORY;

        const response = await putData(requestURL, apiData);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            getAllInventories();
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one inventory.");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  // Remove tag from inventory
  const removeTagFromInventory = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_INVENTORY;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      // console.log("response in remove tag from lead------->", data);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedInventory(null);
      }, 1000);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setinventoryList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      Cell: ({ row }) => (
        <button
          className="action_btn_mui"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasSaveInventory"
          aria-controls="offcanvasSaveInventory"
          onClick={() => {
            setSelectedInventory(row.original._id);
          }}
        >
          <span className="d-block material-symbols-outlined horz_icon">
            more_horiz
          </span>
        </button>
      ),
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    { accessorKey: "stockedon", header: "Stocked On" },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.taglist.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.taglist.map((tag, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium me-1">
                        {tag.title}
                      </span>
                      <Link
                        to="#"
                        className={`${
                          tag.moderator.toString() ===
                            userInfo._id.toString() ||
                          userInfo.role.slug === "ADMIN" ||
                          userInfo.role.slug === "SUPER_ADMIN"
                            ? "d-block"
                            : "d-none"
                        }`}
                        onClick={() => {
                          setSelectedInventory(row.original._id);
                          setSelectedTagId(tag._id);
                          removeTagFromInventory([tag._id], row.original._id);
                        }}
                      >
                        {selectedTagId &&
                        selectedTagId === tag._id &&
                        selectedInventory &&
                        selectedInventory === row.original._id ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary ms-1"
                            role="status"
                            style={{ height: "12px", width: "12px" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <span
                            className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                            style={{ cursor: "pointer" }}
                          >
                            cancel
                          </span>
                        )}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedInventories([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    { accessorKey: "sku", header: "SKU" },
    { accessorKey: "productname", header: "Product Name" },
    { accessorKey: "currentstock", header: "Current Stock" },
    { accessorKey: "stockadded", header: "Added Stock" },
    { accessorKey: "wearhousename", header: "Warehouse" },
    { accessorKey: "supplier", header: "Supplier" },
  ];

  const columns = useMemo(
    () => initialTableColumns,
    [selectedTagId, selectedInventory],
  );

  /* Updates the column visibility state by toggling the visibility of the column with the given accessor key.*/
  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  /* Represents the state of column visibility in the table.*/
  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  //function for column visibility
  const onColumnVisiblityHandler = (newColumnState) => {
    if (typeof newColumnState === "function") {
      const newColumnStateName = newColumnState();
      setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
    } else {
      setVisibleColoumns(newColumnState);
    }
  };

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  //function for change column order
  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  //function for reset filter
  const resetFilterData = () => {
    setGlobalSearch("");
    setRowSelection({});
    setSelectedInventories([]);
    setJsonFilterQuery(null);

    setReloadData(true);

    // reset pagination to default
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });

    setLastPagination({
      pageIndex: 0,
      pageSize: 10,
    });
  };

  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );

    if (selectedIdsArray.length > 0) {
      setSelectedInventories(selectedIdsArray);
    } else {
      setSelectedInventories([]);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (jsonFilterQuery === null) return;

    if (jsonFilterQuery.length > 0) {
      getFilteredInventoryList(debouncedSearch, true);
    } else {
      getAllInventories(debouncedSearch, true);
    }

    setIsDataReady(true);
  }, [jsonFilterQuery]);

  // Search effect — fires when debounced search changes.
  // Skeleton OFF — table stays visible while searching.
  useEffect(() => {
    if (!isDataReady) return;

    if (jsonFilterQuery && jsonFilterQuery.length > 0) {
      getFilteredInventoryList(debouncedSearch, false);
    } else {
      getAllInventories(debouncedSearch, false);
    }
  }, [debouncedSearch]);

  useEffect(() => {
    if (reloadData) {
      getAllInventories("", true);
      setIsFilterReset(true);
      setReloadData(false);
    }
  }, [reloadData]);

  // save the last pagination
  useEffect(() => {
    setLastPagination({
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  // ✅ Debounce — after typing 600ms, setDebouncedSearch will be called
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(globalSearch);
    }, 600);
    return () => clearTimeout(timer);
  }, [globalSearch]);

  /* Closes the alert by updating the state variables.*/
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  const downloadAsExcel = () => {
    if (inventoryList.length > 0) {
      // Define headers
      const headers = [
        t("SKU"),
        t("Product Name"),
        t("Current Stock"),
        t("Added Stock"),
        t("Warehouse"),
        t("Supplier"),
      ];

      // Filter data based on selection
      const filteredList =
        selectedInventories.length > 0
          ? inventoryList.filter((item) =>
              selectedInventories.includes(item._id),
            )
          : inventoryList;

      // Map data to rows
      const data = filteredList.map((item) => [
        item.sku || "",
        item.productname || "",
        item.currentstock || "",
        item.stockadded || "",
        item.wearhousename || "",
        item.supplier || "",
      ]);

      // Create worksheet
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, t("Inventory"));

      // Write to buffer and save
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      const fileName = `${t("Inventory")}_${new Date().toISOString().split("T")[0]}.xlsx`;
      FileSaver.saveAs(blob, fileName);
    }
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_MARKETPLACE")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          {/* ---- common header ---- */}
          <CommonHeader activeOption="Inventory" />

          <div className="container-fluid px-lg-5">
            {/* header */}
            <InventoryHeader
              reloadList={refreshRecords}
              jsonFilterQuery={jsonFilterQuery ?? []}
              selectedInventories={selectedInventories}
              downloadAsExcel={downloadAsExcel}
            />

            {/* table */}
            {!isDataReady || showSkeleton ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={inventoryList} // data from api to be displayed
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{
                    // ✅ If globalSearch exists, use value; otherwise undefined
                    globalFilter: globalSearch || undefined,
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }} //pass our managed row selection state to the table to use
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  onPaginationChange={setPagination} // set pagination
                  autoResetPageIndex={false}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  enableColumnOrdering={true}
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                  // ✅ typing → setGlobalSearch → debounce → setDebouncedSearch → API call
                  onGlobalFilterChange={(value) => setGlobalSearch(value ?? "")}
                />
              </div>
            )}
          </div>

          {/* ----- all pop up render here ----- */}

          <SaveInventoryPopup
            inventoryId={selectedInventory}
            setInventoryId={setSelectedInventory}
            afterPopupCLose={() => {
              setTimeout(() => {
                getAllInventories();
              }, 1000);
            }}
          />

          {/* ----------- delete warning modal ------------ */}
          <DeleteWarningModal
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedInventories([]);
            }}
            onDelete={deleteBulkInventories}
            moduleName={t("inventory")}
          />

          <AddLabelModal
            selectedIds={selectedInventories}
            moduleName="inventory"
            afterTagModalClose={afterModalActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedInventories([]);
            }}
          />

          <InventoryFilterPopup
            moduleSlug="inventorylist"
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={refreshRecords}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
            setColumnOrder={setColumnOrder}
            setVisibleColoumns={setVisibleColoumns}
            columnOrder={columnOrder}
            visibleColoumns={visibleColoumns}
            columns={columns}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default InventoryListBody;
